import { getTimezoneAbbreviation } from '@/shared/lib/util/date';
import moment from 'moment-timezone';
import { create } from 'zustand';

export type AdminStore = {
  timezone: string | null;
  timezoneText: string | null;
  updateTimezone: () => void;
};

export const useAdminStore = create<AdminStore>((set, get) => ({
  timezone: null,
  timezoneText: null,
  updateTimezone: () => {
    const newTimezone = moment.tz.guess();
    if (get().timezone !== newTimezone) {
      set({
        timezone: newTimezone,
        timezoneText: getTimezoneAbbreviation(newTimezone)
      });
    }
  }
}));
